module.exports = __webpack_public_path__ + "static/WEEF-4960cc98c2b29859478df2b18ee3680c.svg";